// STATUS: draft — needs native-speaker check before live
// Romanian visitor messages (task TR1, docs/modules/languages.md s2). Visitor keys only; missing keys fall back to en-GB.
export const roVisitor = {
    'kiosk.pairing.title': 'Configurați acest chioșc',
    'kiosk.pairing.hint': 'Introduceți codul din portalul CloudSign.',
    'kiosk.pairing.go': 'Asociați',
    'kiosk.pairing.codeLabel': 'Cod de asociere',
    'kiosk.pairing.checking': 'Se verifică codul…',
    'kiosk.pairing.clear': 'Ștergeți',
    'kiosk.pairing.back': 'Ștergeți ultima cifră',
    'kiosk.pairing.invalid': 'Acest cod nu este valid sau a expirat. Solicitați unul nou.',
    'kiosk.pairing.noNetwork': 'Nu s-a putut contacta CloudSign. Verificați Wi-Fi și încercați din nou.',
    'kiosk.common.back': 'Înapoi',
    'kiosk.common.next': 'Înainte',
    'kiosk.common.continue': 'Continuați',
    'kiosk.common.cancel': 'Anulați',
    'kiosk.common.yes': 'Da',
    'kiosk.common.no': 'Nu',
    'kiosk.welcome.tap': 'Atingeți aici pentru a vă înregistra sosirea sau plecarea',
    'kiosk.welcome.offline': 'Offline: înregistrările sunt salvate și trimise mai târziu',
    'kiosk.home.title': 'Ce doriți să faceți?',
    'kiosk.home.signIn': 'Înregistrați sosirea',
    'kiosk.home.signOut': 'Înregistrați plecarea',
    'kiosk.home.scan': 'Scanați legitimația mea',
    'kiosk.groups.titleIn': 'În ce calitate vă înregistrați?',
    'kiosk.groups.titleOut': 'În ce calitate vă înregistrați plecarea?',
    'kiosk.groups.hint': 'Alegeți opțiunea care vi se potrivește cel mai bine.',
    'kiosk.groups.repeat': 'Membri obișnuiți',
    'kiosk.pin.hint': 'Introduceți codul PIN din 4 cifre.',
    'kiosk.pin.entered': '{count} din 4 cifre introduse',
    'kiosk.pin.wrong': 'Codul PIN nu este corect. Încercați din nou.',
    'kiosk.pin.locked': 'Prea multe coduri PIN greșite. Introducerea codului PIN este blocată câteva minute. Vă rugăm să solicitați ajutor.',
    'kiosk.pin.clear': 'Ștergeți',
    'kiosk.pin.back': 'Ștergeți ultima cifră',
    'kiosk.identify.title': 'Căutați numele dumneavoastră',
    'kiosk.identify.placeholder': 'Începeți să scrieți numele dumneavoastră',
    'kiosk.identify.none': 'Nu a fost găsită nicio persoană cu acest nume.',
    'kiosk.identify.addSelf': 'Nu sunt pe listă',
    'kiosk.addSelf.title': 'Adăugați-vă',
    'kiosk.name.title': 'Care este numele dumneavoastră?',
    'kiosk.name.label': 'Numele dumneavoastră',
    'kiosk.name.fullNameHint': 'Vă rugăm să indicați prenumele și numele de familie.',
    'kiosk.already.message': 'Sosirea dumneavoastră este deja înregistrată. Doriți să înregistrați plecarea în schimb?',
    'kiosk.already.signOut': 'Înregistrați-mi plecarea',
    'kiosk.questions.titleIn': 'Câteva întrebări rapide',
    'kiosk.questions.titleOut': 'Înainte de a pleca',
    'kiosk.questions.datePlaceholder': 'YYYY-MM-DD',
    'kiosk.questions.acknowledge': 'Am înțeles',
    'kiosk.questions.hostSearch': 'Scrieți numele persoanei pe care o vizitați',
    'kiosk.questions.changeHost': 'Modificați',
    'kiosk.notices.progress': 'Anunțul {n} din {total}',
    'kiosk.notices.accept': 'Am citit acest anunț și îl accept',
    'kiosk.notices.sign': 'Semnați',
    'kiosk.notices.signHere': 'Vă rugăm să semnați cu degetul.',
    'kiosk.signature.pad': 'Caseta de semnătură',
    'kiosk.signature.clear': 'Ștergeți semnătura',
    'kiosk.signature.captured': 'Semnătura a fost salvată',
    'kiosk.photo.title': 'Fotografie',
    'kiosk.photo.hint': 'Priviți spre cameră și atingeți butonul.',
    'kiosk.photo.take': 'Faceți-mi fotografia',
    'kiosk.photo.getReady': 'Pregătiți-vă…',
    'kiosk.photo.retake': 'Faceți din nou fotografia',
    'kiosk.photo.use': 'Folosiți această fotografie',
    'kiosk.photo.skip': 'Săriți peste fotografie',
    'kiosk.photo.failed': 'Fotografia nu a reușit. Încercați din nou.',
    'kiosk.photo.noCamera': 'Camera nu este disponibilă. Puteți continua fără fotografie.',
    'kiosk.photo.privacy': 'Fotografia dumneavoastră este folosită doar pentru legitimație și pentru fișa de vizită.',
    'kiosk.badge.title': 'Legitimația dumneavoastră',
    'kiosk.badge.ask': 'Doriți o legitimație?',
    'kiosk.badge.yes': 'Imprimați legitimația mea',
    'kiosk.badge.no': 'Nu, mulțumesc',
    'kiosk.badge.printing': 'Se imprimă legitimația…',
    'kiosk.badge.done': 'Vă rugăm să vă luați legitimația',
    'kiosk.badge.failed': 'Ne pare rău, legitimația nu a putut fi imprimată. Sosirea dumneavoastră este înregistrată. Vă rugăm să solicitați o legitimație la recepție.',
    'kiosk.signout.title': 'Căutați numele dumneavoastră pentru a înregistra plecarea',
    'kiosk.signout.search': 'Căutați după nume',
    'kiosk.signout.hiddenHint': 'Din motive de confidențialitate, numele nu sunt afișate. Scrieți numele dumneavoastră sau scanați legitimația.',
    'kiosk.signout.empty': 'Nu este nimeni înregistrat.',
    'kiosk.signout.noMatch': 'Nu a fost găsită nicio persoană. Încercați din nou sau scanați legitimația.',
    'kiosk.signout.unnamed': 'Vizitator',
    'kiosk.scan.title': 'Scanați legitimația',
    'kiosk.scan.hint': 'Țineți codul QR de pe legitimație în fața camerei.',
    'kiosk.scan.allow': 'Permiteți accesul la cameră',
    'kiosk.scan.noCamera': 'Camera nu este disponibilă. Vă rugăm să alegeți numele din listă.',
    'kiosk.scan.notBadge': 'Aceasta nu este o legitimație CloudSign. Încercați din nou.',
    'kiosk.scan.notSignedIn': 'Această legitimație nu este înregistrată aici. Vă rugăm să alegeți numele din listă.',
    'kiosk.finish.inTitle': 'Mulțumim, {name}',
    'kiosk.finish.inMessage': 'Sosirea dumneavoastră este înregistrată.',
    'kiosk.finish.outTitle': 'La revedere, {name}',
    'kiosk.finish.outMessage': 'Plecarea dumneavoastră este înregistrată. Drum bun!',
    'kiosk.finish.tap': 'Atingeți pentru a încheia',
    'kiosk.update.title': 'Acest chioșc necesită o actualizare',
    'kiosk.update.message': 'Acest chioșc trebuie actualizat înainte de a putea înregistra sosirea dumneavoastră. Vă rugăm să întrebați la recepție.',
    'kiosk.update.short': 'Necesită actualizare',
    'kiosk.error.required': 'Vă rugăm să răspundeți la această întrebare.',
    'kiosk.error.mustAcknowledge': 'Vă rugăm să bifați pentru confirmare.',
    'kiosk.error.nameRequired': 'Vă rugăm să scrieți numele dumneavoastră.',
    'kiosk.error.fullName': 'Vă rugăm să indicați prenumele și numele de familie.',
    'kiosk.error.tooLong': 'Acest răspuns este prea lung.',
    'kiosk.error.number': 'Vă rugăm să introduceți un număr.',
    'kiosk.error.wholeNumber': 'Vă rugăm să introduceți un număr întreg.',
    'kiosk.error.range': 'Acest număr nu se află în intervalul permis.',
    'kiosk.error.email': 'Vă rugăm să introduceți o adresă de e-mail validă.',
    'kiosk.error.phone': 'Vă rugăm să introduceți un număr de telefon valid.',
    'kiosk.error.date': 'Vă rugăm să introduceți o dată de forma 2026-12-31.',
    'kiosk.error.answerNotAllowed': 'Acest răspuns înseamnă că nu vă puteți înregistra aici. Vă rugăm să vorbiți cu recepția.',
    'kiosk.print.state.ready': 'Imprimanta este pregătită',
    'kiosk.print.state.no_media': 'Imprimanta a rămas fără etichete',
    'kiosk.print.state.cover_open': 'Capacul imprimantei este deschis',
    'kiosk.print.state.media_mismatch': 'În imprimantă sunt încărcate etichetele greșite',
    'kiosk.print.state.busy': 'Imprimanta este ocupată',
    'kiosk.print.state.error': 'Imprimanta semnalează o problemă',
    'kiosk.print.state.unreachable': 'Imprimanta nu poate fi contactată',
    'kiosk.print.state.unknown': 'Starea imprimantei nu este cunoscută',
    'kiosk.home.expected': 'Am o programare',
    'kiosk.home.scanCode': 'Scanați codul meu QR',
    'kiosk.scan.titleCode': 'Scanați codul QR',
    'kiosk.scan.hintCode': 'Țineți în fața camerei codul QR din e-mail, de pe card sau de pe legitimație.',
    'kiosk.scan.invalid': 'Acest cod QR nu este valid aici. Încercați din nou sau alegeți numele din listă.',
    'kiosk.scan.notSupported': 'Acest chioșc nu poate folosi acest tip de cod QR. Alegeți numele din listă.',
    'kiosk.scan.unknownMember': 'Acest cod QR nu este recunoscut la acest chioșc. Alegeți numele din listă.',
    'kiosk.scan.oldCode': 'Acest cod QR a fost înlocuit cu unul nou. Folosiți cel mai recent sau alegeți numele.',
    'kiosk.scan.notHere': 'Acest cod QR nu este pentru acest chioșc.',
    'kiosk.scan.notExpected': 'Nu vă așteptăm astăzi. Vă rugăm să întrebați la recepție.',
    'kiosk.scan.cancelled': 'Această vizită a fost anulată. Vă rugăm să întrebați la recepție.',
    'kiosk.scan.alreadyArrived': 'Acest cod QR a fost deja folosit pentru a înregistra o sosire.',
    'kiosk.scan.expired': 'Acest cod QR a expirat. Vă rugăm să întrebați la recepție.',
    'kiosk.expected.title': 'Cine sunteți?',
    'kiosk.expected.search': 'Începeți să scrieți numele dumneavoastră',
    'kiosk.expected.exactHint': 'Vă rugăm să scrieți numele complet exact cum ni s-a comunicat.',
    'kiosk.expected.requiredHint': 'Trebuie să fiți așteptat pentru a vă înregistra aici. Căutați numele dumneavoastră sau scanați codul QR.',
    'kiosk.expected.none': 'Nu am găsit acest nume pe lista de astăzi. Vă rugăm să întrebați la recepție.',
    'kiosk.expected.empty': 'Momentan nu este așteptată nicio persoană.',
    'kiosk.expected.visiting': 'În vizită la {host}',
    'kiosk.expected.required': 'Trebuie să fiți așteptat pentru a vă înregistra aici. Vă rugăm să întrebați la recepție.',
    'kiosk.signout.outMark': 'Plecat',
    'kiosk.signout.outToday': 'Plecare înregistrată azi',
    'kiosk.hostReply.on_my_way': '{host} este în drum spre dumneavoastră.',
    'kiosk.hostReply.please_wait': '{host} vă roagă să așteptați.',
    'kiosk.hostReply.someone': 'Gazda dumneavoastră',
    'kiosk.hostReply.dismiss': 'OK',
    'kiosk.evacuation.notAllowed': 'Evacuarea nu poate fi începută de la acest chioșc.',
    'kiosk.evacuation.wrongPin': 'Codul PIN nu este corect.',
    'kiosk.evacuation.pinLocked': 'Prea multe coduri PIN greșite. Vă rugăm să așteptați câteva minute.',
    'kiosk.evacuation.startFailed': 'Evacuarea nu a putut fi începută. Încercați din nou.',
    'kiosk.nfc.enrolOffline': 'Acest chioșc este offline. Cardurile pot fi înregistrate doar când este online.',
    'kiosk.nfc.enrolExpired': 'Această înregistrare de card s-a încheiat sau a expirat.',
    'kiosk.nfc.enrolFailed': 'Cardul nu a putut fi înregistrat. Încercați altul.',
    'kiosk.nfc.enrolTapAgain': 'Vă rugăm să apropiați din nou cardul.',
    'kiosk.common.ok': 'OK',
    'kiosk.welcome.stale': 'Acest chioșc a fost offline mult timp. Vă rugăm să informați recepția.',
    'kiosk.welcome.busy': 'Sediul este aglomerat în acest moment. Dacă sunteți în vizită, vă rugăm să informați recepția.',
    'kiosk.welcome.evacuation': 'Evacuare',
    'kiosk.home.delivery': 'Livrez un colet',
    'kiosk.check.seeReceptionTitle': 'Vă rugăm să mergeți la recepție',
    'kiosk.check.warnTitle': 'Înainte de a continua',
    'kiosk.full.short': 'Sediul este plin',
    'kiosk.full.title': 'Sediul este plin',
    'kiosk.full.message': 'Momentan nu putem înregistra mai mulți vizitatori. Vă rugăm să mergeți la recepție.',
    'kiosk.induction.subtitle': 'Instructaj de sănătate și securitate',
    'kiosk.induction.unavailable': 'Instructajul nu este disponibil la acest chioșc. Vă rugăm să mergeți la recepție.',
    'kiosk.induction.videoMissing': 'Videoclipul nu este încă pe acest chioșc. Vă rugăm să citiți textul de mai jos.',
    'kiosk.induction.pdfNote': 'Vă rugăm să citiți textul instructajului de mai jos. Întrebați la recepție dacă doriți documentul.',
    'kiosk.induction.wait': 'Vă rugăm să așteptați {seconds} de secunde',
    'kiosk.induction.startQuiz': 'Începeți întrebările',
    'kiosk.induction.question': 'Întrebarea {n} din {total}',
    'kiosk.induction.chooseMany': 'Alegeți toate răspunsurile corecte.',
    'kiosk.induction.finish': 'Finalizați',
    'kiosk.induction.retryTitle': 'Încă nu',
    'kiosk.induction.retryMessage': 'Unele răspunsuri nu au fost corecte. Vă rugăm să încercați din nou {count}.',
    'kiosk.induction.retryButton': 'Încercați din nou',
    'kiosk.permits.title': 'Autorizațiile dumneavoastră de lucru',
    'kiosk.permits.unavailable': 'Autorizațiile nu pot fi afișate acum. Vă rugăm să mergeți la recepție înainte de a începe lucrul.',
    'kiosk.permits.allAccepted': 'Ați acceptat toate autorizațiile.',
    'kiosk.permits.progress': 'Autorizația {n} din {total}',
    'kiosk.permits.valid': 'De la {from} până la {until}',
    'kiosk.permits.conditions': 'Condiții',
    'kiosk.permits.precautions': 'Măsuri de precauție',
    'kiosk.permits.signHere': 'Semnați aici pentru a accepta, {name}',
    'kiosk.permits.accept': 'Accept această autorizație',
    'kiosk.nfc.blocked': 'Acest card a fost blocat',
    'kiosk.nfc.unknown': 'Card nerecunoscut',
    'kiosk.nfc.enrolTitle': 'Înregistrarea cardurilor',
    'kiosk.nfc.enrolProgress': '{done} din {total} finalizate',
    'kiosk.nfc.enrolTapFor': 'Apropiați cardul pentru',
    'kiosk.nfc.enrolHold': 'Țineți cardul lipit de spatele tabletei.',
    'kiosk.nfc.enrolSaving': 'Se salvează…',
    'kiosk.nfc.enrolOk': 'Card salvat.',
    'kiosk.nfc.enrolDone': 'Toate cardurile sunt înregistrate',
    'kiosk.nfc.noReader': 'Niciun cititor de carduri nu este activat la acest chioșc.',
    'kiosk.evacuation.title': 'EVACUARE',
    'kiosk.evacuation.drillTitle': 'EXERCIȚIU DE EVACUARE',
    'kiosk.evacuation.startTitle': 'Începeți o evacuare',
    'kiosk.evacuation.confirmTitle': 'Începeți o evacuare?',
    'kiosk.evacuation.confirmMessage': 'Aceasta alertează toate persoanele de pe sediu și deschide lista de prezență.',
    'kiosk.evacuation.confirmStart': 'Începeți evacuarea',
    'kiosk.evacuation.leave': 'Părăsiți lista de prezență',
    'kiosk.evacuation.leaveTitle': 'Introduceți codul PIN pentru a părăsi lista de prezență',
    'kiosk.evacuation.returnBanner': 'Evacuare în curs. Atingeți pentru a reveni la lista de prezență.',
    'kiosk.evacuation.offline': 'Offline: marcajele dumneavoastră sunt salvate și vor fi trimise când revine rețeaua.',
    'kiosk.evacuation.localOnly': 'Pornită la acest chioșc offline. Va fi îmbinată cu portalul când revine rețeaua.',
    'kiosk.evacuation.countUnaccounted': 'Nu a fost găsit încă',
    'kiosk.evacuation.countSafe': 'În siguranță',
    'kiosk.evacuation.countMissing': 'Dispărut',
    'kiosk.evacuation.countTotal': 'Pe sediu',
    'kiosk.evacuation.allPoints': 'Toată lumea',
    'kiosk.evacuation.search': 'Căutați după nume',
    'kiosk.evacuation.onlyOpen': 'Încă nu în siguranță',
    'kiosk.evacuation.loading': 'Se încarcă lista de prezență…',
    'kiosk.evacuation.nobody': 'Nimeni de afișat.',
    'kiosk.evacuation.safe': 'În siguranță',
    'kiosk.evacuation.markedSafe': 'ÎN SIGURANȚĂ (atingeți pentru a anula)',
    'kiosk.evacuation.missing': 'Dispărut',
    'kiosk.evacuation.markedMissing': 'DISPĂRUT (atingeți pentru a anula)',
    'kiosk.evacuation.host': 'Gazdă: {name}',
    'kiosk.evacuation.check': 'VERIFICAȚI',
    'kiosk.evacuation.permits': '{count} autorizație(i) deschisă(e)',
    'kiosk.contactless.qrLabel': 'Scanați acest cod cu telefonul pentru a vă înregistra',
    'kiosk.contactless.scanMe': 'Înregistrați-vă cu telefonul',
    'kiosk.courier.whoTitle': 'Pentru cine este coletul?',
    'kiosk.courier.whoHint': 'Scrieți câteva litere din numele persoanei.',
    'kiosk.courier.search': 'Numele persoanei',
    'kiosk.courier.useName': 'Folosiți „{name}”',
    'kiosk.courier.useNameHint': 'Recepția îl va transmite',
    'kiosk.courier.carrierTitle': 'De la ce firmă veniți?',
    'kiosk.courier.forName': 'Colet pentru {name}',
    'kiosk.courier.other': 'Altă firmă',
    'kiosk.courier.otherLabel': 'Numele firmei',
    'kiosk.courier.countTitle': 'Câte colete sunt?',
    'kiosk.courier.howMany': 'Numărul de colete',
    'kiosk.courier.save': 'Gata',
    'kiosk.courier.thanks': 'Mulțumim',
    'kiosk.courier.thanksMessage': 'Am anunțat destinatarul că i-a sosit coletul.',
    'kiosk.support.pinTitle': 'Suport: introduceți codul PIN',
    'kiosk.support.title': 'Suport',
    'kiosk.support.close': 'Închideți',
    'kiosk.support.network': 'Rețea',
    'kiosk.support.online': 'Online',
    'kiosk.support.offline': 'Offline',
    'kiosk.support.queue': 'În așteptarea trimiterii',
    'kiosk.support.oldest': 'Cel mai vechi așteaptă din',
    'kiosk.support.none': 'Niciunul',
    'kiosk.support.deadLetters': 'Refuzate de server (netrimise)',
    'kiosk.support.deadHelp': 'Aceste elemente au fost refuzate de server și rămân pe acest chioșc. Informați administratorul; pagina dispozitivului din portal arată numărul lor.',
    'kiosk.support.configAge': 'Setări actualizate ultima dată',
    'kiosk.support.ageUnknown': 'Niciodată',
    'kiosk.support.ageMinutes': 'acum {n} minute',
    'kiosk.support.ageHours': 'acum {n} ore',
    'kiosk.support.ageDays': 'acum {n} zile',
    'kiosk.support.nfc': 'Cititor de carduri',
    'kiosk.support.nfcReady': 'Pregătit',
    'kiosk.support.nfcOff': 'Dezactivat',
    'kiosk.support.nfcNone': 'Neinstalat',
    'kiosk.support.media': 'Videoclipuri stocate',
    'kiosk.support.mediaMb': '{mb} MB',
    'kiosk.support.headcount': 'Persoane pe sediu (acest chioșc)',
    'kiosk.finish.poweredBy': 'Oferit de CloudSign',
    'kiosk.badge.noMedia': 'Imprimanta de legitimații a rămas fără etichete. Sosirea dumneavoastră este înregistrată. Vă rugăm să informați recepția.',
    'kiosk.badge.mediaMismatch': 'Imprimanta de legitimații are încărcate etichetele greșite. Sosirea dumneavoastră este înregistrată. Vă rugăm să informați recepția.',
    'kiosk.badge.coverOpen': 'Capacul imprimantei de legitimații este deschis. Sosirea dumneavoastră este înregistrată. Vă rugăm să informați recepția.',
    'kiosk.member.menuTitle': 'Ce doriți să faceți?',
    'kiosk.member.signIn': 'Înregistrați-mi sosirea',
    'kiosk.member.updatePhoto': 'Actualizați-mi fotografia',
    'kiosk.member.sendInvite': 'Trimiteți-mi invitația la aplicație',
    'kiosk.memberPhoto.title': 'Actualizați-vă fotografia',
    'kiosk.memberPhoto.saved': 'Fotografia dumneavoastră a fost actualizată.',
    'kiosk.memberPhoto.failed': 'Fotografia nu a putut fi salvată. Încercați din nou sau întrebați la recepție.',
    'kiosk.memberPhoto.offline': 'Acest chioșc este offline, deci fotografia nu poate fi actualizată acum.',
    'kiosk.memberPhoto.notAllowed': 'Fotografia nu poate fi actualizată la chioșc. Vă rugăm să întrebați la recepție.',
    'kiosk.invite.title': 'Obțineți aplicația CloudSign',
    'kiosk.invite.sent': 'Vi s-a trimis pe e-mail un link pentru configurarea aplicației. Verificați căsuța de e-mail.',
    'kiosk.invite.noEmail': 'Nu avem o adresă de e-mail pentru dumneavoastră, deci nu am putut trimite invitația. Vă rugăm să întrebați la recepție.',
    'kiosk.invite.tooMany': 'Ați cerut prea multe invitații astăzi. Încercați din nou mâine.',
    'kiosk.invite.failed': 'Invitația nu a putut fi trimisă. Încercați din nou sau întrebați la recepție.',
    'kiosk.invite.offline': 'Acest chioșc este offline, deci nu se poate trimite o invitație acum.',
    'kiosk.invite.sending': 'Se trimite invitația…',
    'kiosk.language.choose': 'Alegeți limba',
    'kiosk.language.button': 'Limbă',
    'public.language.label': 'Limbă',
    'contactless.thank_you': 'Mulțumim. Sosirea dumneavoastră este înregistrată.',
    'contactless.thank_you_out': 'Mulțumim. Plecarea dumneavoastră este înregistrată.',
    'contactless.poster.title': 'Scanați pentru a vă înregistra',
    'contactless.poster.hint': 'Îndreptați camera telefonului spre cod. Nu este nevoie de nicio aplicație.',
    'check.safety_check.refused': 'Vă rugăm să mergeți la recepție înainte de a vă înregistra.',
    'check.safety_check.alert': 'Admis cu o alertă transmisă recepției (verificare de siguranță).',
    'check.compliance.refused': 'Lipsește un document obligatoriu sau a expirat. Vă rugăm să mergeți la recepție.',
    'check.compliance.warned': 'Lipsește un document obligatoriu sau a expirat.',
    'check.induction.required': 'Vă rugăm să finalizați mai întâi instructajul de la fața locului.',
    'check.capacity.full': 'Sediul este plin în acest moment. Vă rugăm să mergeți la recepție.',
    'check.capacity.warned': 'Înregistrat în timp ce sediul depășea capacitatea.',
    'check.offline': 'Înregistrat în timp ce chioșcul era offline.',
};
//# sourceMappingURL=ro.js.map